
/**
 * Constants for AI Assistant Context configuration
 */

// Component identification
export const COMPONENT_NAME = 'AiAssistantProvider';

// Stable configurations that don't change during component lifecycle
export const STABLE_CONFIGS = {
  componentName: COMPONENT_NAME,
  renderCountThreshold: 50
} as const;

// Default hook configurations
export const DEFAULT_HOOK_CONFIGS = {
  stateCoordination: {
    componentName: COMPONENT_NAME
  },
  sessionManagement: {
    autoLoadDelayMs: 100
  },
  performanceTracking: {
    enabled: true,
    logDebugInfo: true
  }
} as const;

// Error handling configurations
export const ERROR_HANDLING_CONFIGS = {
  maxRetries: 3,
  retryDelayMs: 1000,
  enableRecovery: true
} as const;
